import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Stack,
  Link,
  Text
} from "@chakra-ui/react";
import { Link as RouterLink, useParams } from "react-router-dom";

import QUESTION_MAP from "../data/quizQuestions";
import QuizQuestion from "../components/QuizQuestion";

function QuizQuestionsView() {
  useEffect(() => {
    localStorage.setItem("quizAnswers", JSON.stringify(answers));
  });
  const [answers, setAnswers] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0
  });
  const { qNumber, fName, lName } = useParams();
  return (
    <Stack spacing={10} py={2} px={4} flex="1 0 auto">
      <QuizQuestion
        {...QUESTION_MAP[qNumber]}
        onAnswerSelect={(value) => {
          setAnswers({
            ...answers,
            [qNumber]: QUESTION_MAP[qNumber].options.indexOf(value) + 1
          });
        }}
        selectedAnswer={answers[qNumber]}
        questionNumber={Number(qNumber)}
      />
      {answers[qNumber] !== 0 &&
        QUESTION_MAP[qNumber].confirmContent[answers[qNumber] - 1] !== "" && (
          <Text
            background="#DCEDFF"
            px={4}
            py={4}
            fontSize="14px"
            lineHeight="1.6"
          >
            {QUESTION_MAP[qNumber].confirmContent[answers[qNumber] - 1]}
          </Text>
        )}
      <Box align="center">
        <Link
          as={RouterLink}
          to={
            Number(qNumber) === Object.keys(QUESTION_MAP).length
              ? `/quiz-results/${fName}/${lName}`
              : `/quiz-questions/${Number(qNumber) + 1}/${fName}/${lName}`
          }
        >
          {qNumber === 10 && (
            <Button colorScheme="blue">Get your results</Button>
          )}
          {qNumber !== 10 && <Button colorScheme="blue">Next question</Button>}
        </Link>
      </Box>
    </Stack>
  );
}

export default QuizQuestionsView;
